/** @format */
import React, { useState } from "react";
import { Row, Col, Container, Tab, Nav, Form } from "react-bootstrap";
import Card from "../../../../components/Card";
import { Link } from "react-router-dom";
import ReactFsLightbox from "fslightbox-react";

// images
import img1 from "src/assets/images/page-img/profile-bg1.jpg";
import user1 from "src/assets/images/user/04.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faGooglePlus,
  faYoutube,
  faLinkedin,
  faXTwitter,
  faCodepen,
} from "@fortawesome/free-brands-svg-icons";
import g1 from "src/assets/images/page-img/g2.jpg";
import g2 from "src/assets/images/page-img/g2.jpg";
import g3 from "src/assets/images/page-img/g2.jpg";
import g4 from "src/assets/images/page-img/g2.jpg";
import g5 from "src/assets/images/page-img/g2.jpg";
import g6 from "src/assets/images/page-img/g2.jpg";
import g7 from "src/assets/images/page-img/g2.jpg";
import g8 from "src/assets/images/page-img/g2.jpg";
import g9 from "src/assets/images/page-img/g2.jpg";
import Dashboard from "./dashboard";
import MyProfile from "./my-profile/my-profile";
import AppliedJobs from "./applied-jobs/applied-jobs";
import Bookmark from "./bookmark/bookmark";
import Setting from "./setting/setting";
import { useGetUserMe } from "../../../../api/queries/user.query";
import defaultProfilePic from "src/assets/images/user/i-avatar.png";
import defaultUserCoverPic from "src/assets/images/userBanner.jpeg";
// Fslightbox plugin
const FsLightbox = ReactFsLightbox.default
  ? ReactFsLightbox.default
  : ReactFsLightbox;

const UserProfile = () => {
  const [imageController, setImageController] = useState({
    toggler: false,
    slide: 1,
  });

  const { data: userData, isLoading: isLoadingUserData } = useGetUserMe({
    select: (response) => response.data.user,
  });

  console.log(userData);
  const [isHoveredCover, setIsHoveredCover] = useState(false);
  const [isHoveredProfile, setIsHoveredProfile] = useState(false);

  const handleMouseEnterCover = () => {
    setIsHoveredCover(true);
  };

  const handleMouseLeaveCover = () => {
    setIsHoveredCover(false);
  };

  const handleMouseEnterProfile = () => {
    setIsHoveredProfile(true);
  };

  const handleMouseLeaveProfile = () => {
    setIsHoveredProfile(false);
  };

  const handleEditClick = () => {
    console.log("Edit Profile Picture or Cover");
  };

  return (
    <>
      <FsLightbox
        toggler={imageController.toggler}
        sources={[g1, g2, g3, g4, g5, g6, g7, g8, g9]}
        slide={imageController.slide}
      />
      <div id="content-page" className="content-inner">
        <Container>
          <Row>
            <Col sm={12}>
              <Card>
                <Card.Body className=" profile-page p-0">
                  <div className="profile-header profile-info">
                    <div
                      className="cover-container"
                      style={{ position: "relative" }}
                      onMouseEnter={handleMouseEnterCover}
                      onMouseLeave={handleMouseLeaveCover}
                    >
                      <img
                        loading="lazy"
                        src={defaultUserCoverPic}
                        alt="profile-bg"
                        className="rounded img-fluid bg-light"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                      {isHoveredCover && (
                        <div
                          className="hover-overlay"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: "rgba(128, 128, 128, 0.5)", // Semi-transparent gray
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <button
                            onClick={handleEditClick}
                            className="rounded-full img-fluid"
                            style={{
                              border: "none",
                              cursor: "pointer",
                              background: "transparent",
                            }}
                          >
                            <span
                              className="material-symbols-outlined"
                              style={{ fontSize: "2rem", color: "white" }}
                            >
                              edit
                            </span>
                          </button>
                        </div>
                      )}
                    </div>

                    <div className="user-detail text-center mb-3">
                      <div
                        className="profile-img"
                        onMouseEnter={handleMouseEnterProfile}
                        onMouseLeave={handleMouseLeaveProfile}
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <img
                          loading="lazy"
                          src={
                            userData?.profile_picture.url
                              ? userData.profile_picture.url
                              : defaultProfilePic
                          }
                          alt="profile-img"
                          className="avatar-130 img-fluid"
                        />
                        {isHoveredProfile && (
                          <div
                            className="hover-overlay"
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              background: "rgba(128, 128, 128, 0.5)", // Semi-transparent gray
                              borderRadius: "50%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <button
                              onClick={handleEditClick}
                              className="rounded-full img-fluid"
                              style={{
                                border: "none",
                                cursor: "pointer",
                                background: "transparent",
                              }}
                            >
                              <span
                                className="material-symbols-outlined"
                                style={{ fontSize: "2rem", color: "white" }}
                              >
                                edit
                              </span>
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="profile-detail">
                        <h3>Paul Molive</h3>
                      </div>
                    </div>

                    <div className="profile-info py-5 px-md-5 px-3 d-flex align-items-center justify-content-between position-relative">
                      <div className="social-links">
                        <ul className="social-data-block d-flex align-items-center justify-content-between list-inline p-0 m-0">
                          <li className="text-center pe-3">
                            <Link to="#">
                              <FontAwesomeIcon
                                icon={faFacebook}
                                style={{ color: "#4267B2", fontSize: "24px" }}
                              />
                            </Link>
                          </li>
                          <li className="text-center pe-3">
                            <Link to="#">
                              <FontAwesomeIcon
                                icon={faXTwitter}
                                style={{
                                  color: "black",
                                  fontSize: "24px",
                                }}
                              />
                            </Link>
                          </li>
                          <li className="text-center pe-3">
                            <Link to="#">
                              <FontAwesomeIcon
                                icon={faInstagram}
                                style={{
                                  color: "#C13584",
                                  fontSize: "24px",
                                }}
                              />
                            </Link>
                          </li>
                          <li className="text-center pe-3">
                            <Link to="#">
                              <FontAwesomeIcon
                                icon={faGooglePlus}
                                style={{
                                  color: "#DB4437",
                                  fontSize: "24px",
                                }}
                              />
                            </Link>
                          </li>
                          <li className="text-center pe-3">
                            <Link to="#">
                              <FontAwesomeIcon
                                icon={faYoutube}
                                style={{
                                  color: "#FF0000",
                                  fontSize: "24px",
                                }}
                              />
                            </Link>
                          </li>
                          <li className="text-center pe-3">
                            <Link to="#">
                              <FontAwesomeIcon
                                icon={faLinkedin}
                                style={{
                                  color: "#0077B5",
                                  fontSize: "24px",
                                }}
                              />
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="material-symbols-outlined me-2">
                          work
                        </span>
                        <Form.Check.Label className="me-2">
                          I'm open for Job
                        </Form.Check.Label>
                        <Form.Check
                          type="switch"
                          id="flexSwitchCheckDefault"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Card>
              <Card.Body className="">
                <Tab.Container defaultActiveKey="firstTabs3">
                  <Nav variant="tabs" id="nav-tab" role="tablist" as={"ul"}>
                    <Nav.Item as={"li"}>
                      <Nav.Link
                        eventKey="firstTabs3"
                        variant=" d-flex align-items-center"
                        id="nav-home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-home"
                        type="button"
                        role="tab"
                        aria-controls="nav-home"
                        aria-selected="true"
                      >
                        Dashboard
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as={"li"}>
                      <Nav.Link
                        eventKey="secondTabs3"
                        variant=""
                        id="nav-profile-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-profile"
                        type="button"
                        role="tab"
                        aria-controls="nav-profile"
                        aria-selected="false"
                      >
                        My Profile
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as={"li"}>
                      <Nav.Link
                        eventKey="thirdTabs3"
                        variant=""
                        id="nav-job-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-contact"
                        type="button"
                        role="tab"
                        aria-controls="nav-contact"
                        aria-selected="false"
                      >
                        Applied Jobs
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as={"li"}>
                      <Nav.Link
                        eventKey="fourthTabs3"
                        variant=""
                        id="nav-bookmark-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-contact"
                        type="button"
                        role="tab"
                        aria-controls="nav-contact"
                        aria-selected="false"
                      >
                        Bookmarks
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as={"li"}>
                      <Nav.Link
                        eventKey="fifthTabs3"
                        variant=""
                        id="nav-setting-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-contact"
                        type="button"
                        role="tab"
                        aria-controls="nav-contact"
                        aria-selected="false"
                      >
                        Settings
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content>
                    <Tab.Pane
                      eventKey="firstTabs3"
                      id="nav-home"
                      role="tabpanel"
                      aria-labelledby="nav-home-tab"
                    >
                      <Dashboard />
                    </Tab.Pane>
                    <Tab.Pane
                      id="nav-profile"
                      eventKey="secondTabs3"
                      role="tabpanel"
                      aria-labelledby="nav-profile-tab"
                    >
                      <MyProfile />
                    </Tab.Pane>
                    <Tab.Pane
                      id="nav-contact"
                      eventKey="thirdTabs3"
                      role="tabpanel"
                      aria-labelledby="nav-contact-tab"
                    >
                      <AppliedJobs />
                    </Tab.Pane>
                    <Tab.Pane
                      id="nav-contact"
                      eventKey="fourthTabs3"
                      role="tabpanel"
                      aria-labelledby="nav-contact-tab"
                    >
                      <Bookmark />
                    </Tab.Pane>
                    <Tab.Pane
                      id="nav-contact"
                      eventKey="fifthTabs3"
                      role="tabpanel"
                      aria-labelledby="nav-contact-tab"
                    >
                      <Setting />
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </Card.Body>
            </Card>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default UserProfile;
